import { FC } from 'react';
import theme from '../../../theme';
import Icon from '../Icon';

interface Props {
  width?: string;
  /** A theme colour name (e.g. 'primary') or any CSS colour. */
  color?: string;
}

const PlusIcon: FC<Props> = ({ width = '18', color }) => (
  <Icon
    name="add"
    size={Number(width) || width}
    color={(theme.colors.general as Record<string, string>)[color] || color}
  />
);

export default PlusIcon;
